export class Incidente {
  id: number;
  nome: string;
  resumoCaso: string;
  itensClassificacaoFinal: number[];
  classificacao: string;
  classificacoes: number[];
  listaclassif: string;
  listaencam: string;
  listaencaminhamentos: number[];
  enviado: boolean;
  descricaoencam: string;
  descEncam: string;
  txtEncam: { [chave: number]: string };
  dadosEncam: { [chave: string]: string };
  nomeencam: string;
  itensEncamFinal: number[];
  txtEncaminhamentos: { [chave: number]: string };
  encaminhado: boolean;
  flagPsicologico: boolean;
  encamPsic: boolean;
  idEntrevista: number;
  protocolo: string;
  descricaofinaliz: string;
  finaliz: number;
}



// WEBPACK FOOTER //
// ./src/app/incidente/incidente.ts